<template>
  <div class="contenttopspaning">
      <RadioGroup v-model="reportRadio" class="row no-margin bg_light">
        <div class="col-lg-4 equal_padding">
          <div class="newcard_box heightcard_box">
            <div class="newcardblock radiobox_grid">
              <Radio
                v-for="report in getReports"
                :label="report.id"
                :disabled="!isDepotSet"
                @change="reportChange"
                :key="report.id">
                {{report.name}}
                <Info :reportHeaders="report.reportHeaders" />
              </Radio>
            </div>
          </div>
        </div>
        <div class="col-lg-4 equal_padding">
        </div>
        <div class="col-lg-4 equal_padding">
        </div>
      </RadioGroup>
    </div>
</template>

<script>

import { reports } from '@/constants/reportConstants';
import Info from './action/Info';

export default {
  props: ['isDepotSet', 'resetRadio'],
  components: {
    Info,
  },
  data() {
    return {
      reportRadio: 0,
      reports,
    };
  },
  computed: {
    getReports() {
      return this.reports.filter(report => (report.permission ? this.$hasPermission(report.permission) : true)) || [];
    },
  },
  methods: {
    reportChange() {
      this.$emit('reportChange', this.reportRadio);
    },
  },
  watch: {
    resetRadio() {
      this.reportRadio = 0;
    },
  },
};
</script>
